module.exports = __webpack_public_path__ + "media/images/writer-offering-heading-icon-f7e6e950dbf8b55494df4bc8ebdc08ad.png";